<template>
  <div class="procurement">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-config="slipStatus != 'JSDZT06' ? { trigger: 'click', mode: 'row' } : ''"
      show-footer
      :max-height="tableHeight"
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'procurement',
    props: ['slipStatus'],
    components: {
      // inputNumberAd,
    },
    computed: {
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.contractCreateDate',
            title: this.$t('batchAdd.procurement.contractCreateDate'),
          }, // 合同日期
          {
            field: 'serializationJsonData.supplierName',
            title: this.$t('batchAdd.procurement.supplierName'),
          }, // 供应商
          {
            field: 'serializationJsonData.contractNo',
            title: this.$t('batchAdd.procurement.contractNo'),
          }, // 采购管理号
          {
            field: 'serializationJsonData.externalContractNo',
            title: this.$t('batchAdd.procurement.externalContractNo'),
          }, // 外部采购合同号
          {
            field: 'serializationJsonData.contractStatus',
            title: this.$t('batchAdd.procurement.contractStatusName'),
            formatter: this.formatterStatus,
          }, // 合同状态
          {
            field: 'serializationJsonData.contractDetailNo',
            title: this.$t('batchAdd.procurement.contractDetailNo'),
          }, // 合同行项目
          {
            // 合同数量
            field: 'serializationJsonData.productQuantity',
            title: this.$t('batchAdd.procurement.productQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.productQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 合同单价
            field: 'serializationJsonData.businessContractUnitPrice',
            title: this.$t('batchAdd.procurement.businessContractUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessContractUnitPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 合同金额
            field: 'serializationJsonData.businessContractTotalAmount',
            title: this.$t('batchAdd.procurement.businessContractTotalAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessContractTotalAmount
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 付款金额
            field: 'serializationJsonData.payAmount',
            title: this.$t('batchAdd.procurement.payAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.payAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 交付数量
            field: 'serializationJsonData.deliveredQuantity',
            title: this.$t('batchAdd.procurement.deliveredQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.deliveredQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.invoiceQuantity',
            title: this.$t('batchAdd.procurement.invoiceQuantity'), // 收票数量
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.invoiceQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.serializationJsonData.invoiceQuantity}
                    max={99999999999.999}
                    min={0}
                    precision={this.$globalVar.qPoint}
                    onInput={(val) => this.invoiceQuantityChange(val, row)}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 收票金额
            field: 'serializationJsonData.invoiceAmount',
            title: this.$t('batchAdd.procurement.invoiceAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.invoiceAmount)}
                  </span>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      formatterStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('contract_status', cellValue);
      },
      invoiceQuantityChange(val, row) {
        let item = row.serializationJsonData;
        item.invoiceQuantity = val;
        item.invoiceAmount = this.$cal.calCommon(
          item.businessContractUnitPrice,
          val,
          '*',
          'amount'
        );
        this.$refs.table.updateData();
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.productQuantity',
          'serializationJsonData.businessContractTotalAmount',
          'serializationJsonData.payAmount',
          'serializationJsonData.unCollectionQuantity',
          'serializationJsonData.deliveredQuantity',
          'serializationJsonData.invoiceQuantity',
          'serializationJsonData.invoiceAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
